import React from "react";
import { oneOfType, node, string, bool } from "prop-types";

const Header = ({
  children,
  description = null,
  className = "",
  alignToLeft = false,
}) => (
  <div
    className={`${
      !alignToLeft ? "row text-center justify-content-center" : ""
    } ${className}`}
  >
    <div className={!alignToLeft ? "col-md-8" : ""}>{children}</div>
    <div className={!alignToLeft ? "col-md-7" : ""}>
      <p className="text-lightGrey fontSize-18 d-none d-md-block">
        {description}
      </p>
    </div>
  </div>
);

Header.propTypes = {
  children: oneOfType([node, string]),
  description: string,
  className: string,
  alignToLeft: bool,
};

export default Header;
